import img_01 from '../images/EximBank/B01.png'


export const EximBankData = [
    {
        step: 1,
        image: img_01,
        text: "facePay_by_bank.exim_bank.dowload.0"
    },       
]